import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled } from '@ant-design/icons';
import { Modal, Col, Row, Table, Space, Button, Form, FormInstance, Select, Input } from 'antd';
import { AlignType } from 'rc-table/lib/interface';

import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { IEmailPessoaFisica } from "./InterfacePessoaFisica";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { lista_tipoEmail } from "../../../config/Contantes";

interface IProps {
  form: FormInstance<any>;
  emails: IEmailPessoaFisica[];
  setEmails: React.Dispatch<React.SetStateAction<IEmailPessoaFisica[]>>;
  color: any;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
}

const { Option } = Select;
const PessoaFisicaEmail = ({ form, emails, setEmails, color, manter }: IProps) => {
  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo edição
  const [exibirModalPfEmail, setExibirModalPfEmail] = useState(false);
  const [exibirEmailCadastrado, setExibirEmailCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");


  useEffect(() => {
    if (emails && emails.length === 0) {
      setExibirEmailCadastrado("none")
    } else {
      setExibirEmailCadastrado("inline")
      setValoresAuxiliares();
    }
  }, [emails]);

  const setValoresAuxiliares = (() => {
    emails.forEach(email => {
      lista_tipoEmail.forEach(e => {
        if (email.csTpEmail === e.enum) {
          email.tipoEmail = e.tipoEmail
        }
      })
    })

  })


  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // PASSA O MODAL PARA O MODO EDIÇÃO
    }
  }, [estadoModal])

  const handlerTipoEmail = async (value: any) => {
    form.setFieldsValue({
      tipoEmail: value.children,
      csTpEmail: value.key,
    });
  };


  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir novo e-mail", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalPfEmail(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalPfEmail(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalPfEmail(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarEmail = () => {
    form
      .validateFields([
        "teEmail",
        "csTpEmail",
        "tipoEmail",
      ])
      .then(() => {
        controleDaGrid("incluir");
        setDadosEmail();
        // successMessage(estadoModal === 3 ? "E-mail Alterado" : "E-mail Adicionado");

      })
      .catch((error) => {
        errorMessage("Campo obrigatório não preechido");
      });
  };

  function setDadosEmail() {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setEmails(pre => {
        return pre.map(mail => {
          if (mail.emEdicao) {
            return ({
              idPessoaFisicaEmail: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaEmail")) : -1,
              teEmail: form?.getFieldValue("teEmail"),
              csTpEmail: form.getFieldValue("csTpEmail"),
              tipoEmail: form.getFieldValue("tipoEmail"),
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return mail
          }
        })
      });
    } else {
      setEmails([
        ...emails,
        {
          idPessoaFisicaEmail: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaEmail")) : -1,
          teEmail: form?.getFieldValue("teEmail"),
          csTpEmail: form.getFieldValue("csTpEmail"),
          tipoEmail: form.getFieldValue("tipoEmail").toUpperCase(),
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);
    }

    form.resetFields([
      "teEmail",
      "csTpEmail",
      "tipoEmail",
    ]);

    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Email",
      dataIndex: "",
      render: (IEmail: IEmailPessoaFisica) => <>{IEmail.teEmail}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Tipo",
      dataIndex: "",
      render: (IEmail: IEmailPessoaFisica) => <>{IEmail.tipoEmail}</>,
    },
    {
      key: "3",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IEmail: IEmailPessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  form.setFieldsValue({
                    "idPessoaFisicaEmail": IEmail.idPessoaFisicaEmail,
                    "teEmail": IEmail.teEmail,
                    "csTpEmail": IEmail.csTpEmail,
                    "tipoEmail": IEmail.tipoEmail,
                  });
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  emails.forEach(email => {
                    if (email === IEmail) {
                      email.statusReg = 1;
                      email.touched = true;
                      email.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      email.emEdicao = false;
                    }
                  })
                  IEmail.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (IEmail?.idPessoaFisicaEmail && IEmail?.idPessoaFisicaEmail < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setEmails(emails.filter((email) => email !== IEmail));
                }}
              />
            </div>

            <div style={{ display: (IEmail?.idPessoaFisicaEmail && IEmail?.idPessoaFisicaEmail > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IEmail?.statusReg === 1 || IEmail?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    IEmail.touched = true; // MARCA O REGISTRO ALTERADO.
                    IEmail.statusReg = (IEmail.statusReg === 1 ? 2 : 1);
                    setEmails(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(mail => {
                        if (mail.idPessoaFisicaEmail === IEmail.idPessoaFisicaEmail) {
                          return IEmail;
                        } else {
                          return mail;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IEmail?.statusReg === 1 || IEmail?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IEmail.touched = true; // MARCA O REGISTRO ALTERADO.
                    IEmail.statusReg = (IEmail.statusReg === 1 ? 2 : 1);
                    setEmails(pre => {
                      return pre.map(mail => {
                        if (mail.idPessoaFisicaEmail === IEmail.idPessoaFisicaEmail) {
                          return IEmail;
                        } else {
                          return mail;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },
  ];

  return (
    //<Card title='E-mails' variant="borderless" style={{ width: "100%" }}>
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirEmail"
        type="primary"
        shape="round"
        onClick={() => {
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirEmail");
        }}
        icon={<PlusOutlined />}
      >
        Incluir E-mail
      </Button>

      <>

        <Modal title="E-mail" open={exibirModalPfEmail}
          style={{ top: 20 }}
          destroyOnHidden={true}
          onCancel={() => {
            setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
            controleDaGrid("cancelar");
            form.resetFields([
              "teEmail",
              "csTpEmail",
              "tipoEmail",
            ]);
          }}
          closable={false}
          cancelText="Cancelar"
          cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          onOk={() => {
            validarEmail();
          }}
          okText={estadoModal === 3 ? "Alterar" : "Incluir"}
          okButtonProps={{ shape: "round", icon: <CheckOutlined /> }}
        >
          <Row>
            <Col xs={16} sm={16}>
              <Form.Item label='E-mail'
                labelCol={{ span: 16 }}
                labelAlign="left"
                name='teEmail'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Digite um email válido",
                    type: "email",
                  },
                ]}
              >
                <Input
                  maxLength={100}
                  placeholder="e-mail"
                  style={{
                    textTransform: "lowercase",
                    backgroundColor: color.emailColor,
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={8} sm={8}>
              <Form.Item label="Tipo de E-mail" name="tipoEmail"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "O Tipo de E-mail é obrigatório",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Tipo'
                  onChange={(_, index) => {
                    handlerTipoEmail(index);
                  }}
                >
                  {lista_tipoEmail?.map((e: any) => (
                    <Option key={e.enum} value={e.enum}>
                      {e.tipoEmail}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Modal>

      </>

      <Row style={{ display: exibirEmailCadastrado }}>
        <Col
          xs={24}
          sm={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={emails} pagination={false} />
        </Col>
      </Row>

      {/* </Card> */}
    </>
  )
};

export default PessoaFisicaEmail;